import { Button, notification } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectLicenseList, setSliderStatus } from "../../Body/api/redux";
// import Logo from "../../../img/alborz-logo-black.png";

export default () => {

  return (
    <>
      {" "}
      {window.location.origin + "/img/Logo.png"&& (
        <a className="navbar-brand" href="#">
          <img src={window.location.origin + "/img/Logo.png"} />
        </a>
      )}
      <div className="d-flex gap-10">
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
      </div>
    </>
  );
};
